import { GridRowSelectionModel } from '@mui/x-data-grid-premium'
import { useQueryClient } from '@tanstack/react-query'
import { useSnackbarContext } from 'context/SnackbarProvider/SnackbarProvider'
import { useState } from 'react'
import { useBatchUpdateLeads, type LeadUpdateItem } from './useBatchUpdateLeads'

export interface DynamicMassUpdateData {
  [field: string]: any
}

const useMassUpdateLeads = () => {
  const { mutate: batchUpdateLeads } = useBatchUpdateLeads()
  const { showSnackbar } = useSnackbarContext()
  const [isUpdating, setIsUpdating] = useState<boolean>(false)
  const queryClient = useQueryClient()

  const handleMassUpdate = (massUpdateData: DynamicMassUpdateData, rowSelectionModel: GridRowSelectionModel): void => {
    console.log('[MassUpdate] massUpdateData:', massUpdateData)
    setIsUpdating(true)
    const updates: LeadUpdateItem[] = []

    Object.entries(massUpdateData).forEach(([field, value]) => {
      // Extract value from array if it's wrapped in one (from MassUpdateTypeSelect)
      let actualValue = value
      if (Array.isArray(value) && value.length === 1) {
        actualValue = value[0]
      } else if (Array.isArray(value) && value.length === 0) {
        return // Skip empty arrays
      }

      const hasMeaningfulValue =
        actualValue !== undefined &&
        (typeof actualValue === 'string'
          ? actualValue.trim().length > 0
          : typeof actualValue === 'object' && actualValue !== null
          ? Object.keys(actualValue).length > 0
          : true)

      if (!hasMeaningfulValue) return

      Array.from(rowSelectionModel.ids).forEach(leadId => {
        updates.push({
          lead_uuid: leadId as string,
          fieldName: field,
          newValue: actualValue,
        })
      })
    })

    console.log('[MassUpdate] Final update payload:', updates)

    batchUpdateLeads(updates, {
      onSuccess: () => {
        setIsUpdating(false)
        showSnackbar(
          rowSelectionModel.ids.size === 1
            ? 'Lead updated successfully'
            : `${rowSelectionModel.ids.size} Leads updated successfully`,
          'success'
        )

        // Invalidate and refetch the leads query
        queryClient.invalidateQueries({ queryKey: ['leads'] })
      },
      onError: () => {
        setIsUpdating(false)
        showSnackbar(rowSelectionModel.ids.size === 1 ? 'Lead update failed' : 'Leads update failed', 'error')
      },
    })
  }

  return { handleMassUpdate, isUpdating }
}

export default useMassUpdateLeads
